import { useAuth } from "pages/authenticated/AuthContext"

const useAuthService = () => {
  const {
    login,
    register,
    loginWithGoogle,
    loginWithFacebook,
    loginWithMicrosoft,
    logout,
    token,
    user,
    isAuthenticated
  } = useAuth()

  return {
    login,
    register,
    loginWithGoogle,
    loginWithFacebook,
    loginWithMicrosoft,
    logout,
    token,
    user,
    isAuthenticated,
    getUserCredentials: () => user,
  }
}

export default useAuthService
